/**
* 随手记
*/

import '@common/polyfill/src/promise'
import useragent from '@common/useragent'
import clientBridge from '@common/client/src/bridge'

import { callbackHandler } from '../utils'

import BaseAuth from './base'

// 刷新token的次数，防止死循环
let refreshTokenTimes = 3

class SuishoujiAuth extends BaseAuth {
  constructor(options) {
    super(options)
    if (useragent.isSuishouji) {
      // 随手记
      this.isClientHit = true
    }
    // 随手记因客户端原因，暂时不依赖cookie
    this.isRelyOnIsLoginCookie = false
  }
  // 请求随手记协议
  callClientBridge() {
    let params = {}
    if (this.loginType.force || this.loginType.tokenError) {
      params = {
        type: 2,
      }
    } else if (this.loginType.silent) {
      params = {
        type: 3,
      }
    } else if (this.loginType.tokenExpire) {
      params = {
        type: 2,
        code: 4,
      }
    } else {
      params = {
        type: 1,
      }
    }
    return new Promise((resolve) => {
      clientBridge.call(clientBridge.uriSuishouji('requestLogin', params, 'appLoginCallback'), 'appLoginCallback', (data) => {
        resolve(data)
      })
    })
  }
  // 处理客户端返回的数据
  async clientDataHandler() {
    const tokenExpire = () => {
      this.resetLoginType('tokenExpire')
      if (refreshTokenTimes > 0) {
        this.login()
        refreshTokenTimes--
      } else {
        console.error('登录失败', 'Api login Error: refresh times out')
        callbackHandler(this.options.error, { msg: '登录失败' })
      }
    }
    const tokenError = () => {
      this.resetLoginType('force')
      this.login()
    }
    try {
      const clientData = await this.callClientBridge()
      const _clientData = JSON.parse(clientData)
      // HACK:因静默登录返回数据不明确，先单独处理
      if (this.loginType.silent || _clientData.success) {
        this.requestLoginApi({
          userName: (_clientData.result && _clientData.result.name) || null,
          password: (_clientData.result && _clientData.result.password) || null,
          token: (_clientData.result && _clientData.result.token) || null
        }, {
          tokenExpire,
          tokenError,
          accountError: tokenError,
        })
      } else {
        callbackHandler(this.options.cancel)
      }
    } catch (error) {
      console.error('Suishouji Login Error:', error)
      callbackHandler(this.options.error, { msg: '登录失败，请重试' })
    }
  }
  // 获取token
  getToken() {
    if (!this.isClientHit) return undefined
    return this.callClientBridge().then((data) => {
      const _data = JSON.parse(data)
      // HACK:因静默登录返回数据不明确，先单独处理
      if (_data.success && _data.result && _data.result.token) {
        return {
          token: _data.result.token
        }
      }
      return {}
    }).catch((error) => {
      console.error('GetToken Error:', error)
      callbackHandler(this.options.error, { msg: '登录失败，请重试' })
    })
  }
  // 登录
  login() {
    if (!this.isClientHit) return
    if (this.checkIsLogin()) {
      this.requestLoginApiSuccessCallback()
    } else {
      this.clientDataHandler()
    }
  }
}

export default SuishoujiAuth



// WEBPACK FOOTER //
// ./node_modules/@finance/login/src/client/suishouji.js